// features/fund/schemas/FundSchemas.js
// Mirrors the enums on the Spring Boot side (com.company.providentfund.domain.enums.*)

export const FUND_TYPE = [
    { value: "PROVIDENT_FUND", name: "กองทุนสำรองเลี้ยงชีพ", nameEn: "Provident Fund" },
    { value: "EMPLOYEE_WELFARE_FUND", name: "กองทุนสงเคราะห์ลูกจ้าง", nameEn: "Employee Welfare Fund" },
    { value: "PRIVATE_TEACHER_FUND", name: "กองทุนสงเคราะห์ครูเอกชน", nameEn: "Private teacher aid fund contribution" },
];

export const FUND_STATUS = [
    { value: "ACTIVE", name: "ใช้งาน", nameEn: "Active" },
    { value: "INACTIVE", name: "ไม่ใช้งาน", nameEn: "Inactive" },
];

export const CONTRIBUTION_CALCULATION_BASIS = [
    { value: "BY_ENROLLMENT_MONTH", name: "ตามเดือนที่สมัครกองทุน", nameEn: "By enrollment month" },
    { value: "BY_ENROLLMENT_DATE", name: "ตามวันที่สมัครกองทุน", nameEn: "By enrollment date" },
];

export const MEMBERSHIP_ELIGIBILITY = [
    { value: "FROM_START_DATE", name: "วันเริ่มงาน", nameEn: "From start date" },
    { value: "AFTER_PROBATION", name: "ผ่านทดลองงาน", nameEn: "After probation" },
];

export const CRITERIA_BASIS = [
    { value: "YEARS_OF_SERVICE", name: "อายุงาน", nameEn: "Years of service" },
    { value: "MEMBERSHIP_AGE", name: "อายุสมาชิก", nameEn: "Membership age" },
];

export const TIME_UNIT = [
    // { value: "DAY", name: "วัน", nameEn: "Day" },
    { value: "MONTH", name: "เดือน", nameEn: "Month" },
    { value: "YEAR", name: "ปี", nameEn: "Year" },
];

export const ENTRY_EXIT_POLICY = [
    {
        value: "NO_REJOIN_AFTER_LEAVING",
        name: "เมื่อลาออกจากกองทุนแล้วจะสมัครกองทุนอีกไม่ได้",
        nameEn: "Cannot rejoin once left",
        needsWaitingPeriod: false,
        needsMaxRejoin: false,
    },
    {
        value: "UNLIMITED_REJOIN_NO_WAIT",
        name: "สมัครและลาออกได้โดยไม่จำกัดจำนวนครั้ง",
        nameEn: "Unlimited rejoin, no waiting period",
        needsWaitingPeriod: false,
        needsMaxRejoin: false,
    },
    {
        value: "UNLIMITED_REJOIN_WITH_WAITING_PERIOD",
        name: "สมัครใหม่ได้โดยไม่จำกัดจำนวนครั้ง แต่ต้องเว้นระยะตามที่กำหนด",
        nameEn: "Unlimited rejoin, waiting period required",
        needsWaitingPeriod: true,
        needsMaxRejoin: false,
    },
    {
        value: "LIMITED_REJOIN_WITH_WAITING_PERIOD",
        name: "จำกัดจำนวนครั้งและต้องเว้นระยะตามที่กำหนด",
        nameEn: "Limited rejoin count, waiting period required",
        needsWaitingPeriod: true,
        needsMaxRejoin: true,
    },
];

export const toOptions = (list, lang = "th") =>
    list.map((o) => ({ label: lang === "en" ? o.nameEn : o.name, value: o.value }));

// The "from/to" column headers in both line-item tables depend on which
// basis was picked above them (อายุงาน vs อายุสมาชิก). Falls back to
// years-of-service wording until the person has made a choice.
export const getCriteriaColumnLabels = (criteria, lang = "th") => {
    if (criteria === "MEMBERSHIP_AGE") {
        return lang === "en"
            ? { from: "Membership age from", to: "Membership age to" }
            : { from: "อายุสมาชิกตั้งแต่", to: "อายุสมาชิกสิ้นสุด" };
    }
    return lang === "en"
        ? { from: "Service years from", to: "Service years to" }
        : { from: "อายุงานตั้งแต่", to: "อายุงานสิ้นสุด" };
};

export const findPolicy = (value) => ENTRY_EXIT_POLICY.find((p) => p.value === value);

export const emptyRateRule = () => ({
    serviceFrom: undefined,
    serviceFromUnit: "YEAR",
    serviceTo: undefined,
    serviceToUnit: "YEAR",
    employeeRatePercent: undefined,
    employeeMaxRatePercent: undefined,
    companyRatePercent: undefined,
});

export const emptyVestingRule = () => ({
    serviceFrom: undefined,
    serviceFromUnit: "YEAR",
    serviceTo: undefined,
    serviceToUnit: "YEAR",
    employeeBenefitPercent: undefined,
});